import { isNotEmpty } from "neetocist";
import { Pane, Typography, Spinner } from "neetoui";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import SharePaneBody from "./SharePaneBody";

const ShareRecordingPane = ({
  recordingUrl = null,
  recordingUrls = [],
  totalDuration,
  getCurrentTimestamp,
  isOpen,
  onClose,
  isLoading = false,
  preview,
  enableAutoplayAndMuteFlags = false,
  size = "large",
  ...otherProps
}) => {
  const { t } = useTranslation();

  const recordingUrlsToShare = isNotEmpty(recordingUrls)
    ? recordingUrls
    : [recordingUrl];

  return (
    <Pane
      {...{ isOpen, onClose, size, ...otherProps }}
      data-testid="share-pane"
    >
      <Pane.Header>
        <Typography style="h2">
          {t("neetoMolecules.shareRecording.title")}
        </Typography>
      </Pane.Header>
      <Pane.Body className="neeto-ui-border-gray-200 border-t px-0 py-6">
        {isLoading ? (
          <Spinner className="mx-auto" />
        ) : (
          <SharePaneBody
            {...{
              enableAutoplayAndMuteFlags,
              getCurrentTimestamp,
              isOpen,
              onClose,
              preview,
              totalDuration,
            }}
            recordingUrls={recordingUrlsToShare}
          />
        )}
      </Pane.Body>
    </Pane>
  );
};

ShareRecordingPane.propTypes = {
  /**
   * Recording URL used for building the share link.
   */
  recordingUrl: PropTypes.string,
  /**
   * Recording URLs used for building the share link.
   */
  recordingUrls: PropTypes.array,
  /**
   * Total duration of the content being shared.
   */
  totalDuration: PropTypes.number.isRequired,
  /**
   * A function that returns current playback time of the recorded content in seconds.
   */
  getCurrentTimestamp: PropTypes.func.isRequired,
  /**
   * Boolean indicating whether the pane is open or not.
   */
  isOpen: PropTypes.bool.isRequired,
  /**
   * Function to close the pane.
   */
  onClose: PropTypes.func.isRequired,
  /**
   * Boolean indicating whether content is loading or not.
   */
  isLoading: PropTypes.bool,
  /**
   * Component to render as a preview of the recording.
   */
  preview: PropTypes.elementType,
  /**
   * Size of the pane.
   */
  size: PropTypes.oneOf(["extraLarge", "large", "small"]),
};

export default ShareRecordingPane;
